import useWorkingProjectColorsByV2Names from '@/utils/use-working-project-colors-by-v2-names';
import { STATS_CARD_BACKGROUND_COLOR } from './constants';
import getRelativeContrastColor from '@/utils/colors/generate-relative-contrasting-color';
import getComputedColorVariableValue from '@/utils/get-computed-color-variable-value';
import useGetWorkingProjectThemeMode from '@/utils/use-get-working-project-theme-mode';
import { EPaletteModes } from '@/types/theme-packs.types';

const useGetStatsIconColors = (props?: { from?: string; to?: string }): { from: string; to: string } => {
  const from = props?.from || 'var(--secondary-pink-500)';
  const to = props?.to || 'var(--secondary-pink-500)';

  const themeMode = useGetWorkingProjectThemeMode();
  const { accents } = useWorkingProjectColorsByV2Names();

  if (!accents?.length) {
    return { from, to };
  }

  // use hard coded hex values just in case computed value is undefined (it's unlikely, but TS requires a fallback)
  // these values come directly from --gray-900 in color-scale.css
  const hardCodedFallbackContrast = themeMode === EPaletteModes.Dark ? '#24232b' : '#f3f2f5';

  const accentHex = accents[0];
  const adjustedAccentForAccessibility = getRelativeContrastColor(
    accentHex,
    getComputedColorVariableValue(STATS_CARD_BACKGROUND_COLOR) || hardCodedFallbackContrast
  );

  return {
    from: adjustedAccentForAccessibility,
    to: adjustedAccentForAccessibility,
  };
};

export default useGetStatsIconColors;
